<template>
    <transition name="fade">
        <div v-show="isOn" class="prevent-interaction"></div>
    </transition>
</template>
<script>
    export default {
        name:'PreventInteraction',
        data () {
            return {
                isOn:false
            }
        },
        methods:{
            setPreventer: function (isOn) {
                this.isOn = isOn
            }
        },
        videoroom: {
            consentDialog: function (isOn) {
                this.setPreventer(isOn)
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/PreventInteraction.vue